import { render, staticRenderFns } from "./Workdepartmentbudget.vue?vue&type=template&id=6a95686f&scoped=true&"
import script from "./Workdepartmentbudget.vue?vue&type=script&lang=js&"
export * from "./Workdepartmentbudget.vue?vue&type=script&lang=js&"
import style0 from "./Workdepartmentbudget.vue?vue&type=style&index=0&id=6a95686f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a95686f",
  null
  
)

export default component.exports